export { default } from './SpreadViewerRoutesOptions.vue'
